"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = void 0;
const zustand_1 = require("zustand");
exports.useStore = (0, zustand_1.create)((set) => ({
    errorMessage: null,
    loading: false,
    outputContent: '',
    resetStore: () => set({ errorMessage: null, loading: false, outputContent: '', threadId: null }),
    setErrorMessage: (errorMessage) => set({ errorMessage }),
    setLoading: (loading) => set({ loading }),
    setOutputContent: (outputContent) => set({ outputContent }),
    setThreadId: (threadId) => set({ threadId }),
    threadId: null,
}));
